import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accessTokenKey, globalState, baseUrl } from "../utils/config";

function Post() {

    const navigate = useNavigate();
    const [type, setType] = useState("");
    const [nature, setNature] = useState("");
    const [posting, setPosting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [state, setState] = useState(globalState.state);

    async function postJob() {
        setPosting(true);

        try {
            const form = document.getElementById("form-post-job");
            const formData = new FormData(form);

            const salaryFrom = parseInt(form.salary_from.value) || 0;
            const salaryTo = parseInt(form.salary_to.value) || 0;

            if (salaryTo < salaryFrom) {
                swal.fire("Error", "Salary to should be greater than salary from.", "error");
                return;
            }

            const response = await axios.post(
                baseUrl + "/api/jobs/create",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const id = response.data.id;

                swal.fire("Post Job", response.data.message, "info")
                    .then(function () {
                        navigate("/jobs/" + id)
                    });
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setPosting(false);
        }
    }

    async function fetchCategories() {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("type", "job");

            const response = await axios.post(
                baseUrl + "/api/categories/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setCategories(response.data.categories);
            } else {
                // swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        fetchCategories();

        globalState.listen(function (newState, updatedState) {
            setState(newState);
        });
    }, []);

    const styles = {
        description: {
            height: "150px"
        },
        bgWhite: {
            backgroundColor: "white"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Post a Job</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Post a Job</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Post a Job</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                { (state.user == null && !loading) ? (
                                    <p className="text-center"><Link to="/login">Login</Link> to post a Job.</p>
                                ) : !loading ? (
                                    <>
                                        { state.user?.type == "recruiter" ? (
                                            <>
                                                <p className="mb-4">Create and publish job listings to attract potential candidates. The listing becomes visible to job seekers, enabling them to apply directly. It simplifies the hiring process for companies.</p>

                                                <form onSubmit={ function (event) {
                                                    event.preventDefault();
                                                    postJob();
                                                } } id="form-post-job">
                                                    <div className="row g-3">

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" name="title" placeholder="Job Title" required />
                                                                <label>Job Title</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <select name="type" className="form-control"
                                                                    defaultValue={ type }
                                                                    onChange={ function (event) {
                                                                        setType(event.target.value);
                                                                    } }
                                                                    style={ styles.bgWhite }>
                                                                    <option value="remote">Remote</option>
                                                                    <option value="on_site">On-site</option>
                                                                    <option value="hybrid">Hybrid</option>
                                                                </select>
                                                                <label>Type</label>
                                                            </div>
                                                        </div>

                                                        { ["on_site", "hybrid"].includes(type) && (
                                                            <div className="col-md-6">
                                                                <div className="form-floating">
                                                                    <input type="text" className="form-control" name="location" placeholder="Location" />
                                                                    <label>Location</label>
                                                                </div>
                                                            </div>
                                                        ) }

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <select name="category" className="form-control"
                                                                    style={ styles.bgWhite }>
                                                                    <option value="">Select Category</option>

                                                                    { categories.map(function (category, index) {
                                                                        return (
                                                                            <option key={ `category-${ index }` }
                                                                            value={ category.category }>{ category.category }</option>
                                                                        );
                                                                    }) }
                                                                </select>
                                                                <label>Category</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <select name="nature" className="form-control"
                                                                    value={ nature }
                                                                    onChange={ function (event) {
                                                                        setNature(event.target.value);
                                                                    } }
                                                                    style={ styles.bgWhite }>
                                                                    <option value="full_time">Full-time</option>
                                                                    <option value="part_time">Part-time</option>
                                                                </select>
                                                                <label>Job Nature</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <select className="form-control bg-white" name="currency" required>
                                                                    <option>Select currency</option>

                                                                    { state.settings && state.settings.currencies && (
                                                                        <>
                                                                            { state.settings.currencies.map(function (currency) {
                                                                                return (
                                                                                    <option key={ `currency-${ currency }` }
                                                                                        value={ currency }>{ currency.toUpperCase() }</option>
                                                                                );
                                                                            }) }
                                                                        </>
                                                                    ) }
                                                                </select>
                                                                <label>Currency</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="number" min="0" className="form-control" name="salary_from" placeholder="From" />
                                                                <label>Salary From</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="number" min="0" className="form-control" name="salary_to" placeholder="To" />
                                                                <label>Salary To</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="number" min="1" className="form-control"
                                                                    name="vacancies"
                                                                    defaultValue="1"
                                                                    placeholder="Vacancies" />
                                                                <label>Vacancies</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <textarea name="description" className="form-control"
                                                                    style={ styles.description }></textarea>
                                                                <label>Description</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <select name="status" className="form-control"
                                                                    defaultValue="active"
                                                                    style={ styles.bgWhite }>
                                                                    <option value="active">Active</option>
                                                                    <option value="in_active">In-active</option>
                                                                </select>
                                                                <label>Status</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <button className="btn btn-primary w-100 py-3" type="submit"
                                                                disabled={ posting }>Post Job</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </>
                                        ) : (
                                            <p className="mb-4 text-center">Kindly <Link to="/login">login</Link> with a recruiter account.</p>
                                        ) }
                                    </>
                                ) : (
                                    <></>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Post;